import { render, staticRenderFns } from "./ComposicaoDoRebanhoMedioPorUaAbsoluto.vue?vue&type=template&id=ba102474&scoped=true&"
import script from "./ComposicaoDoRebanhoMedioPorUaAbsoluto.vue?vue&type=script&lang=js&"
export * from "./ComposicaoDoRebanhoMedioPorUaAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba102474",
  null
  
)

export default component.exports